import type { ConditionValue, QuestionCondition, ShowIf, SurveyQuestionInput } from 'shared'

type Translate = (key: string, options?: Record<string, unknown>) => string

/** What a rule says, as a short sentence for whoever is reading the survey's structure. */
export function describeShowIf(
  showIf: ShowIf,
  questions: Pick<SurveyQuestionInput, 'code' | 'config'>[],
  t: Translate,
): string {
  const parts = showIf.conditions.map((condition) => describeCondition(condition, questions, t))
  return parts.join(showIf.match === 'any' ? t('surveys.condition.or') : t('surveys.condition.and'))
}

export function describeCondition(
  condition: QuestionCondition,
  questions: Pick<SurveyQuestionInput, 'code' | 'config'>[],
  t: Translate,
): string {
  const source = questions.find((question) => question.code === condition.question)
  const label = (value: string | number | boolean) =>
    typeof value === 'string'
      ? (source?.config?.options?.find((option) => option.value === value)?.label ?? value)
      : typeof value === 'boolean'
        ? t(value ? 'common.yes' : 'common.no')
        : String(value)

  const value: ConditionValue | undefined = condition.value
  const shown =
    value === undefined ? '' : Array.isArray(value) ? value.map(label).join(', ') : label(value)

  return [condition.question, t(`surveys.condition.op_${condition.op}`), shown].filter(Boolean).join(' ')
}
